import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=0287403e&"
import script from "./drafts.vue?vue&type=script&lang=js&"
export * from "./drafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports